import { render, staticRenderFns } from "./VideoCallsBarIcon.vue?vue&type=template&id=2b9bb99e&"
import script from "./VideoCallsBarIcon.vue?vue&type=script&lang=js&"
export * from "./VideoCallsBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports